import View from './Category'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const Category = connect(mapStateToProps)(View)

export default Category
